import { render, staticRenderFns } from "./CreateCompanyEmployeeModalForm.vue?vue&type=template&id=4053f291&scoped=true&"
import script from "./CreateCompanyEmployeeModalForm.vue?vue&type=script&lang=ts&"
export * from "./CreateCompanyEmployeeModalForm.vue?vue&type=script&lang=ts&"
import style0 from "./CreateCompanyEmployeeModalForm.vue?vue&type=style&index=0&id=4053f291&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4053f291",
  null
  
)

export default component.exports